import { Guid } from "guid-typescript";

import { ContentSection } from ".";

export class ContentHome {
	public static readonly $type: string = "ContentHome";
	public readonly $type: string = ContentHome.$type;

	public id: Guid = Guid.createEmpty();
	public title: string = "";
	public backgroundURL: string = "";
	public sections: ContentSection[] = [];
}
